module.exports = __webpack_public_path__ + "img/ИФ-1(А)-040.5539381f.png";